var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgExclamationMark = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  "data-name": "Layer 1",
  viewBox: "0 0 1080 1080"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M540 0C241.77 0 0 241.77 0 540s241.77 540 540 540 540-241.77 540-540S838.23 0 540 0zm-83.52 208.72h167v185.59l-27.84 232H484.32l-27.84-232zM540 871.28c-48.25 0-88.15-39.9-88.15-88.16S491.75 695 540 695s88.15 39.9 88.15 88.15-39.9 88.13-88.15 88.13z",
  fill: "#d71515"
})));
export default SvgExclamationMark;